import { useEffect } from "react";
import scanStore from "@/store/scanStore";

const GTAG_SCRIPT_ID = "google-analytics-script";

export default function GoogleAnalytics() {
  const { googleAnalyticsId } = scanStore();

  useEffect(() => {
    if (!googleAnalyticsId) return;

    if (!document.getElementById(GTAG_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = GTAG_SCRIPT_ID;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`;
      script.async = true;
      document.head.appendChild(script);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    // Must use `arguments` object (not rest params) — gtag.js expects Arguments type
    // eslint-disable-next-line prefer-rest-params
    w.gtag = function gtag() { w.dataLayer.push(arguments); };
    w.gtag("js", new Date());
    w.gtag("config", googleAnalyticsId);
  }, [googleAnalyticsId]);

  return null;
}
